<app-handler-items 
    (listItemComplete)="savePurchaseOrder($event)" 
    [itemsData]="purchaseOrderData" 
    [addNewItem]="true"
    [addProvider]="true" 
    [addAuthorize]="true" 
    [addReceptionDate]="true" 
    [showPrintButton]="true"
    (printButton)="printPurchaseOrder($event)"
    [titleDialog]="'Orden de Compra'" 
    [replyRoute]="'/almacen/orden_compra'"
    [editHistoryInventory]="historyInventoryData"
    [urlItemCombo]="urlGetItemsWarehouse"
    [view]="view"  >
</app-handler-items>